export default __webpack_public_path__ + "static/media/Padron_7000Open.cc2aa27c.jpg";